import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'season-events',
	templateUrl: "./season-events.component.html",
	styleUrls: ["./season-events.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class  SeasonEventsComponent {
	showSeasonEventListSelection: boolean = false;

	hideSeasonEventListSelection() {
		this.showSeasonEventListSelection = false;
	}

	displaySeasonEventListSelection() {
		this.showSeasonEventListSelection = true;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/season-events/season-events.component.ts